






import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ActionMethod } from "vuex";
import SignalRHub from "@/services/SignalRHub";
import { GenericReferral, SignalREvents } from "@/types/types";

@Component({})
export default class ESpoedSignalRContainer extends Vue {
  @Getter("referrals", { namespace: "espoed" })
  referrals!: Array<GenericReferral>;

  referralHub?: SignalRHub = undefined;

  @Action("loadReferralDetails", { namespace: "espoed" })
  loadReferralDetails!: ActionMethod;

  @Action("updatedPatientNumber", { namespace: "espoed" })
  updatedPatientNumber!: ActionMethod;

  @Action("socketConnected")
  socketConnected!: ActionMethod;

  @Action("socketDisconnected")
  socketDisconnected!: ActionMethod;

  created(): void {
    this.referralHub = new SignalRHub();
    this.referralHub.startSignalR();

    if (this.referralHub) {
      this.referralHub.registerOnConnectedHandler(this.onConnectedHandler);
      this.referralHub.registerOnDisconnectedHandler(
        this.onDisconnectedHandler,
      );
      this.referralHub.hubProxy.on(
        SignalREvents.UpdatePatientNumber,
        this.updatedPatientNumberHandler,
      );
      this.socketConnected();
    } else {
      // eslint-disable-next-line no-console
      console.error("Unable to register handlers with SignalR hub");
    }
  }

  beforeDestroy(): void {
    if (this.referralHub) {
      this.referralHub.hubProxy.off(
        SignalREvents.UpdatePatientNumber,
        this.updatedPatientNumberHandler,
      );

      this.referralHub.stopSignalR();
    }
  }

  onConnectedHandler() {
    this.socketConnected();
  }
  onDisconnectedHandler() {
    this.socketDisconnected();
  }

  updatedPatientNumberHandler(fieldEncounterId: string, patientNumber: string) {
    this.updatedPatientNumber({
      fieldEncounterId: fieldEncounterId,
      patientNumber: patientNumber,
    });
  }
}
